import { ComponentProps, FC } from 'react';
import { AutocompleteElement, useFormContext } from 'react-hook-form-mui';

import { useAllCertifications } from '../../../../../services/hooks/useAllCertifications';

interface Props
  extends Omit<ComponentProps<typeof AutocompleteElement>, 'options'> {
  disabled?: boolean;
}

export const CertificationsAutocomplete: FC<Props> = (props) => {
  const { setValue } = useFormContext();
  const { data: certificationsRes, isLoading } = useAllCertifications();

  const options = (certificationsRes?.data || []).map((c) => ({
    id: c.id,
    label: c.name,
  }));

  return (
    <AutocompleteElement
      loading={isLoading}
      options={options}
      autocompleteProps={{
        disabled: props.disabled,
        onChange: (event, value) => {
          setValue(props.name, value?.id);
        },
        getOptionLabel: (option) => {
          if (option.label) {
            return option.label;
          }

          return options.find((c) => c.id === Number(option))?.label;
        },
      }}
      {...props}
    />
  );
};
